import request from '@/sheep/request'

// 创建心愿达成支付单
export const createRedeemOrder = (data : { wishId : string, price : number }) => {
	return request({
		url: '/wish/travel/create-redeem-order',
		method: 'POST',
		data
	})
}

// 心愿达成支付成功后更新状态
export const handleRedeemPaySuccess = (payOrderId : string) => {
	return request({
		url: '/wish/travel/handle-redeem-pay-success',
		method: 'POST',
		params: { payOrderId }
	})
}